<template>
  <div class="mainViewFrame">
    <img class="bg" :src="images.bg" />
    <div class="mainViewFrameContainer">
      <div class="mainView">
        <div class="header">
          <img class="back" :src="images.back" @click="goBack()" />
          <slot name="rightBtn"></slot>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { BG, IMG_BACK } from "../assets";

export default {
  name: "MainViewFrame",
  components: {},
  props: {},
  data() {
    return {
      images: {
        bg: BG,
        back: IMG_BACK
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 返回事件
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else if (window.history.length === 1) {
        if (location.origin.includes("coding61.com")) {
          location.href = "https://www.coding61.com/index/CogaSelect";
        } else {
          location.href = "https://app.bcjiaoyu.com/index/CogaSelect";
        }
      }
    }
  },
  created() {},
  destroyed() {},
  mounted() {
    console.log("回到顶部---base");
    document.documentElement.scrollTop = 0
  }
};
</script>

<style lang="less" scoped>
.mainViewFrame {
  background-color: #6b45e1;
  width: 100%;
  /* height: 100%; */
  min-width: 1100px;
  min-height: 100%;

  background-size: 100%;
  position: relative;
}
.bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
.mainViewFrameContainer {
  width: 1000px;
  /* min-height: 100%;
  min-height: 680px; */
  /* height: 100%; */
  margin: 0 auto;
  // padding-top: 30px;
  padding-bottom: 30px;
  /* background-color: red; */

  /* display: flex;
  flex-direction: column; */
  z-index: 200;
  position: relative;
}
.mainView {
  .header {
    color: #ff6600;
    font-size: 40px;
    /* text-align: center; */
    height: 44px;
    line-height: 44px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: 30px;
    padding-bottom: 30px;
    .back {
      height:44px;
      cursor: pointer;
    }
    .title {
      height: 44px;
    }
  }
}
</style>
